<template>
  <div class="header-main">
    <span v-if="$route.meta.closable" class="back-button" @click="() => closeAction()"><i class="icon-cross"></i></span>
    <span v-else-if="$route.meta.backable" class="back-button" @click="() => backAction()"><i class="icon-cross"></i></span>
    <RouterLink :to="{ name: 'studyList' }" class="main-title" />
    <div class="ui-helper">
      <span>{{ studyName }}</span>
      <a v-if="!isDesktop && study" :class="['nav-cta', { active: $route.hash === '' }]" @click="studyParams"
        ><i class="icon-cog"></i> {{ $t('settingHelper.studyParameters') }}</a
      >
      <a v-if="$route.meta.exportable" class="nav-cta" @click="exportStudy"><i class="icon-export"></i> {{ $t('export') }}</a>

      <LanguageSelector />
      <LoginDropdown />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LoginDropdown from '@/components/Topbar/LoginDropdown';
import LanguageSelector from '@/components/Topbar/LanguageSelector';
import { useSignalR } from '@dreamonkey/vue-signalr';

export default {
  name: 'HeaderMain',

  components: {
    LoginDropdown,
    LanguageSelector,
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      isDesktop: 'isDesktop',
      study: 'study',
    }),

    studyName() {
      return this.study ? this.study.name : '';
    },
  },

  created() {
    this.$socket = useSignalR();
  },

  methods: {
    closeAction() {
      if (this.study && this.study.id) {
        this.$router.push({
          name: this.isDesktop ? 'synthesis' : 'result',
          params: { studyId: this.study.id },
          hash: this.isDesktop ? '' : '#synthesis',
        });
      } else {
        this.$router.push({ name: 'studyList' });
      }
    },

    backAction() {
      this.$router.go(-1);
    },

    resetViews() {
      if (!this.isDesktop) {
        this.$store.dispatch('resetFilters');
        this.$socket.invoke('action', { action: 'selectMenu', parameters: 'INTERSTICIEL' });
      }
    },

    studyParams() {
      this.$router.push({ hash: '' });
      if (!this.isDesktop) {
        this.$socket.invoke('action', { action: 'selectMenu', parameters: '' });

        if (this.study && this.study.collaborators_total > 2000) {
          const id = this.study.id || this.$route.params.studyId;
          this.$store.dispatch('uploadRawData', { id: id, content: this.$store.getters.screen() }).then(result => {
            this.$socket.invoke('action', { action: 'tvBlob', parameters: result });
          });
        } else {
          this.$socket.invoke('action', { action: 'tvData', parameters: this.$store.getters.screen() });
        }
      }
    },

    exportStudy() {
      const id = this.$route.params.studyId;
      this.$store.dispatch('updateCurrentModal', {
        component: 'ExportStudyList',
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.header-main {
  height: 50px;
  background-color: colors.$white-color;
  box-sizing: border-box;
  border-top: 3px solid colors.$red-active-color;
  display: flex;
  align-items: center;
  padding: 0 24px 0 0;
  border-bottom: 1px solid #e3e3e3;
  .back-button {
    margin-right: 0.6em;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 34px;
    overflow: hidden;
    cursor: pointer;
    i {
      color: #bc141a;
      font-size: 2em;
      border-right: 1px solid #e4e1d8;
    }
    & + .main-title {
      margin-left: 8px;
    }
  }
  .main-title {
    height: calc(100% - 16px);
    background-image: url('./../assets/CommuterLogo-Black.svg');
    background-repeat: no-repeat;
    background-size: contain;
    margin: 8px 0 8px 24px;
    font-size: 32px;
    flex: 1;
    color: colors.$stone-color;
    font-family: 'Golden Plains';
    cursor: pointer;
  }
  .ui-helper {
    display: flex;
    align-items: center;
    height: 100%;

    > span {
      margin-right: 1rem;
      font-size: 0.7rem;
      font-weight: 600;
    }
  }
  .nav-cta {
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
    transition:
      color 0.3s ease,
      all 0.4s ease;
    height: 100%;
    &.user-button {
      padding: 0 12px 0 4px;
      justify-content: center;
      height: 100%;
      width: 192px;
      border-left: solid 1px colors.$white-color;
      border-right: solid 1px colors.$white-color;
      box-sizing: border-box;

      i {
        font-size: 20px;
        margin-right: 8px;
      }

      .name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .arrow {
        $size: 6px;
        width: $size;
        height: $size;
        transform: rotate(45deg);
        border-right: 2px solid colors.$stone-color;
        border-bottom: 2px solid colors.$stone-color;
        border-radius: 1px;
        margin: -2px 4px 2px 12px;
      }

      &.active {
        color: colors.$stone-color;
        border-left: solid 1px colors.$clear-border-color;
        border-right: solid 1px colors.$clear-border-color;
      }
    }

    &.icon-button {
      justify-content: center;
      width: 50px;
      height: 100%;
      border-left: solid 1px colors.$white-color;
      border-right: solid 1px colors.$white-color;

      &.active {
        color: colors.$stone-color;
        border-left: solid 1px colors.$clear-border-color;
        border-right: solid 1px colors.$clear-border-color;
      }
    }

    i {
      font-size: 2em;
      margin-right: 0.1em;
      transition: color 0.3s ease;
    }
    &:first-child {
      margin-left: 45px;
      padding-right: 15px;
    }
    & + .nav-cta {
      margin-left: 30px;
    }
    &.active,
    &:hover {
      color: colors.$stone-color;
      i {
        color: colors.$main-color;
      }
    }
  }
}
</style>
